export enum AppointmentCancelRescheduleReasonCode {
  HoursOfService = 'HOURS_OF_SERVICE',
  EquipmentBreakdown = 'EQUIPMENT_BREAKDOWN',
  ReceiverRejectedOrRescheduled = 'RECEIVER_REJECTED_OR_RESCHEDULED',
  CarrierCapacityOrAvailability = 'CARRIER_CAPACITY_OR_AVAILABILITY',
  SevereWeather = 'SEVERE_WEATHER',
  PreviousStopDelays = 'PREVIOUS_STOP_DELAYS',
  IncorrectShipmentDocumentation = 'INCORRECT_SHIPMENT_DOCUMENTATION',
  Other = 'OTHER'
}

/**
 * Order carriers and warehouse users see the reasons in on the cancel/reschedule dropdowns.
 * "Other" is always last.
 */
export const APPOINTMENT_CANCEL_RESCHEDULE_REASON_CODES: AppointmentCancelRescheduleReasonCode[] = [
  AppointmentCancelRescheduleReasonCode.HoursOfService,
  AppointmentCancelRescheduleReasonCode.EquipmentBreakdown,
  AppointmentCancelRescheduleReasonCode.ReceiverRejectedOrRescheduled,
  AppointmentCancelRescheduleReasonCode.CarrierCapacityOrAvailability,
  AppointmentCancelRescheduleReasonCode.SevereWeather,
  AppointmentCancelRescheduleReasonCode.PreviousStopDelays,
  AppointmentCancelRescheduleReasonCode.IncorrectShipmentDocumentation,
  AppointmentCancelRescheduleReasonCode.Other
];

export const APPOINTMENT_CANCEL_RESCHEDULE_OTHER_REASON_CODE =
  AppointmentCancelRescheduleReasonCode.Other;

/**
 * Maps each reason code to the i18n key suffix (under the `cancelRescheduleReasons` namespace in
 * each app's `appointment.json` locale files) used to display its localized label. Codes are
 * persisted/compared; labels are localized per app so a future translation pass only touches
 * locale files, not this shared list.
 */
export const APPOINTMENT_CANCEL_RESCHEDULE_REASON_I18N_KEYS: Record<
  AppointmentCancelRescheduleReasonCode,
  string
> = {
  [AppointmentCancelRescheduleReasonCode.HoursOfService]: 'hoursOfService',
  [AppointmentCancelRescheduleReasonCode.EquipmentBreakdown]: 'equipmentBreakdown',
  [AppointmentCancelRescheduleReasonCode.ReceiverRejectedOrRescheduled]:
    'receiverRejectedOrRescheduled',
  [AppointmentCancelRescheduleReasonCode.CarrierCapacityOrAvailability]:
    'carrierCapacityOrAvailability',
  [AppointmentCancelRescheduleReasonCode.SevereWeather]: 'severeWeather',
  [AppointmentCancelRescheduleReasonCode.PreviousStopDelays]: 'previousStopDelays',
  [AppointmentCancelRescheduleReasonCode.IncorrectShipmentDocumentation]:
    'incorrectShipmentDocumentation',
  [AppointmentCancelRescheduleReasonCode.Other]: 'other'
};
